import { SkillLevel, SocioEmotionalSkill } from "../../socio-emotional-skills-test/socio-emotional-skills-test.models";


export function getLevel(skill: SocioEmotionalSkill, score: number): SkillLevel {
  const level = skill.levels.find(level => score >= level.minScore && score <= level.maxScore);

  return level;
}